<cdk-virtual-scroll-viewport itemSize="180" [ngClass]="scrollClass">
  <mat-accordion>
    <div fxLayout="row" fxLayoutGap="5pt" fxLayoutAlign="start center" class="shipments-header">
      <mat-icon class="material-icons-outlined black">local_shipping</mat-icon>
      <span><b>Shipments</b></span>
    </div>
    <ng-container *ngIf="shipments | filter: searchShipment as filterShipments">
      <mat-expansion-panel class="result-panel bg-white" *cdkVirtualFor="let shipment of filterShipments">
        <mat-expansion-panel-header>
          <div fxLayout="row" fxLayoutGap="5pt" fxLayoutAlign="start center" class="cheader">
            <div fxFlex="15" fxLayout="column">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5pt">
                <span><b>BOL: </b> <a [routerLink]="['/shipment-master/load-list/', shipment.loadID, shipment.shipmentID]" class="detail-title"> {{ shipment.bol }} </a> </span>
                <mat-icon click-stop-propagation [appClipboardCopy]="shipment.bol" class="material-icons-outlined text-size-13 clickable">content_copy</mat-icon>
              </div>              
              <span><b>BOL Version: </b> {{ shipment.bolVersion }} </span>
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5pt">
                <b>Status:</b>
                <span>
                    {{ shipment.shipmentStatusDesc }}
                  </span>
              </div>
              <div><b>Remi To Line: </b> {{ shipment.remiToLine }} </div>
            </div>
            <div fxFlex="75" fxLayout="row" class="middle-container" fxLayoutAlign="start center">
              <div fxFlex="48" fxLayout="row" fxLayoutGap="5px">
                <div fxLayout="column" fxLayoutAlign="start center">
                  <mat-icon class="sky-blue">location_on</mat-icon>
                </div>
                <div fxFlex="50" fxLayout="column" fxLayoutAlign="start start">
                  <span class="text-flux-blue"> {{ shipment.shipperAddrLine1 }} </span>
                  <span> {{ shipment.shipperName }} </span>
                  <span> {{ shipment.shipperCity }} - {{ shipment.shipperStateProvince }} , {{ shipment.shipperPostalCode }}</span>
                  <span> {{ shipment.shipperCountry }} - {{ shipment.shipperCountryCode }} </span>
                </div>
                <div fxFlex="40" fxLayout="column" fxLayoutAlign="start start">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5pt">
                    <span><b>Pickup</b></span>
                  </div>
                  <span><b>Earliest: </b > {{ shipment.pickupDateEarliest | date: 'MM/dd/yyyy' }}</span>
                  <span><b>Latest: </b>{{ shipment.pickupDateLatest | date: 'MM/dd/yyyy' }}</span>
                  <span><b>Planned: </b> {{ shipment.pickupDatePlanned | date: 'MM/dd/yyyy' }} </span>
                  <span><b>Actual: </b> {{ shipment.pickupDateActual | date: 'MM/dd/yyyy' }} </span>
                </div>
              </div>
              <div fxFlex="4" fxFlexAlign="start">
                <mat-icon class="material-icons-outlined middle-container__icon orange">east</mat-icon>
              </div>
              <div fxFlex="48" fxLayout="row" fxLayoutGap="5px">
                <div fxLayout="column" fxLayoutAlign="start center">
                  <mat-icon class="flux-blue">location_on</mat-icon>
                </div>
                <div fxFlex="50" fxLayout="column" fxLayoutAlign="start start">
                  <span class="text-navy"> {{ shipment.consigneeAddrLine1 }} </span>
                  <span> {{ shipment.consigneeName }} </span>
                  <span> {{ shipment.consigneeCity }} - {{ shipment.consigneeStateProvince }} , {{ shipment.consigneePostalCode }} </span>
                  <span> {{ shipment.consigneeCountry }} - {{ shipment.consigneeCountryCode }} </span>
                </div>
                <div fxFlex="40" fxLayout="column" fxLayoutAlign="start start">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5pt">
                    <span><b>Delivery</b></span>
                  </div>
                  <span><b>Earliest: </b > {{ shipment.deliveryDateEarliest | date: 'MM/dd/yyyy' }}</span>
                  <span><b>Latest: </b>{{ shipment.deliveryDateLatest | date: 'MM/dd/yyyy' }}</span>
                  <span><b>Planned: </b> {{ shipment.deliveryDatePlanned | date: 'MM/dd/yyyy' }} </span>
                  <span><b>Actual: </b> {{ shipment.deliveryDateActual | date: 'MM/dd/yyyy' }} </span>
                </div>
              </div>
            </div>
            <div fxFlex="15" fxLayout="column" fxLayoutAlign="start start">
              <span><b>DomInt: </b>{{ shipment.domInt?.trim()?.toLowerCase() === 'd' ? 'Domestic' : 'International' }}</span>
              <span><b>Directions: </b> {{ shipment.directionsDesc }}</span>
              <span><b>Expedited: </b> {{ shipment.expedited === 0 ? 'No' : 'Yes' }}</span>
              <span><b>Mode: </b> {{ shipment.modeDesc }}</span>
            </div>
          </div>
        </mat-expansion-panel-header>
        <br>
        <ng-template matExpansionPanelContent>
          <!-- Start Customer Pricesheet -->
          <div class="pr-5">
            <mat-accordion>
              <mat-expansion-panel class="result-panel">
                <mat-expansion-panel-header>
                  <div fxLayout="row" fxLayoutGap="2pt" class="cheader nested" fxLayoutAlign="start end">
                    <mat-icon class="material-icons-outlined">format_list_bulleted</mat-icon>
                    <span><b>Customer Charges</b></span>
                  </div>
                </mat-expansion-panel-header>
                <!-- Start  Customer Pricesheets -->
                <ng-template matExpansionPanelContent>
                  <div fxLayout="column"
                       fxLayoutGap="2pt"
                       class="result-panel__details"
                       *ngFor="let customerPriceSheet of shipment.customerPricesheets; let index = index;">
                      <div fxLayout="row" fxLayoutAlign="space-between center">
                        <app-info-card [title]="'Carrier Service'" [subtitle]="customerPriceSheet.carrierService" [symbol]="'package_2'"
                          [color]="'sky-blue'">
                        </app-info-card>
                      
                        <app-info-card [title]="'Amount'" [subtitle]="customerPriceSheet.carrierService" [icon]="'attach_money'"
                          [color]="'green'">
                        </app-info-card>
                      
                        <app-info-card [title]="'Alt Amount'"
                          [subtitle]="((customerPriceSheet.amount ? customerPriceSheet.amount : 0) | currency) + ' ' + (customerPriceSheet.customerPricesheetCurrencyCode ?? '')"
                          [icon]="'attach_money'" [color]="'navy'">
                        </app-info-card>
                      
                        <app-info-card [title]="'Version'" [subtitle]="customerPriceSheet.carrierInvVersion" [symbol]="'conversion_path'"
                          [color]="'blue'">
                        </app-info-card>
                      
                        <app-info-card [title]="'Update Date'" [subtitle]="customerPriceSheet.updateDate | date: 'MM/dd/yyyy'"
                          [icon]="'calendar_month'" [color]="'golden'">
                        </app-info-card>
                      </div>
                    <div fxLayout="row" fxLayoutGap="2pt" class="p-10">
                      <div fxFlex="33" fxLayout="column">
                        <span><b>Pre-Program: </b> {{ (customerPriceSheet.preProgramAmount ? customerPriceSheet.preProgramAmount : 0 | currency) }} </span>
                        <span><b>Current Charge: </b> {{ (customerPriceSheet.programAmount ? customerPriceSheet.programAmount : 0) | currency }} </span>
                        <span><b>Log Savings: </b> {{ (customerPriceSheet.logSavingsAmount ? customerPriceSheet.logSavingsAmount : 0) | currency }} </span>
                        <span><b>Lost Saving: </b> {{ (customerPriceSheet.lostSavingsAmount ? customerPriceSheet.logSavingsAmount : 0) | currency }} </span>
                      </div>
                      <div fxFlex="33" fxLayout="column">
                        <span><b>Alt Amount: </b> {{ (customerPriceSheet.foreignAmount ? customerPriceSheet.foreignAmount : 0) | currency }} </span>
                        <span><b>Alt Pre-Program: </b> {{ (customerPriceSheet.foreignPreProgramAmount ? customerPriceSheet.foreignPreProgramAmount : 0) | currency }} </span>
                        <span><b>Alt Program: </b> {{ (customerPriceSheet.foreignProgramAmount ? customerPriceSheet.foreignProgramAmount : 0) | currency }} </span>
                        <span><b>Alt Log Savings: </b> {{ (customerPriceSheet.foreignLogSavingsAmount ? customerPriceSheet.foreignLogSavingsAmount : 0) | currency }} </span>
                        <span><b>Alt Lost Savings: </b> {{ (customerPriceSheet.foreignLostSavingsAmount ? customerPriceSheet.foreignLostSavingsAmount : 0) | currency }} </span>
                      </div>
                      <div fxFlex="33" fxLayout="column">
                        <span class="text-orange"><b>Customer Review: </b>
                          {{ getCustomerReviewStatus(customerPriceSheet.customerReviewStatusID) }}
                            </span>
                      </div>
                    </div>
                    <div fxLayout="column" class="p-10" fxLayoutGap="5px">
                      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="5px">
                        <mat-icon class="material-icons-outlined black">description</mat-icon>
                        <span><b class="text-black">Customer Charges</b></span>
                      </div>
                      <div fxLayout="row" fxLayoutGap="5px" class="table-headers">
                        <div fxFlex="40"><span><b class="text-black">Description</b></span></div>
                        <div fxFlex="20"><span><b class="text-black">Amount</b></span></div>
                        <div fxFlex="20"><span><b class="text-black">Alt Amount</b></span></div>
                        <div fxFlex="20"><span><b class="text-black">Expense Code</b></span></div>
                      </div>
                      <div *ngFor="let customerCharge of customerPriceSheet.customerPricesheetsCharges" fxLayout="row" fxLayoutGap="5px">
                        <div fxFlex="40"><span>{{ customerCharge.chargeDesc }}</span></div>
                        <div fxFlex="20"><span>{{ (customerCharge.amount ? customerCharge.amount : 0) | currency }}</span></div>
                        <div fxFlex="20"><span>{{ (customerCharge.foreignAmount ? customerCharge.foreignAmount : 0) | currency }}</span></div>
                        <div fxFlex="20"><span>{{ customerCharge.expCodesID }}</span></div>
                      </div>
                    </div>
                    <br>
                  </div>
                </ng-template>
                <!-- Finish Customer Pricesheets -->
              </mat-expansion-panel>
              <mat-expansion-panel class="result-panel">
                <mat-expansion-panel-header>
                  <div fxLayout="row" fxLayoutGap="2pt" class="cheader nested" fxLayoutAlign="start end">
                    <mat-icon class="material-icons-outlined">format_list_bulleted</mat-icon>
                    <span><b>Shipment References</b></span>
                  </div>
                </mat-expansion-panel-header>
                <!-- Start Shipment References -->
                <ng-template matExpansionPanelContent>
                  <div fxLayout="column" fxLayoutGap="2pt" class="result-panel__details">
                    <div fxLayout="row" fxLayoutGap="5px" class="table-headers">
                      <div fxFlex="40"><span><b>Description</b></span></div>
                      <div fxFlex="40"><span><b>Value</b></span></div>
                      <div fxFlex="20"><span><b>Is Primary</b></span></div>
                    </div>
                    <div class="cm" *ngIf="shipment.shipmentReferences.length === 0">
                      <div fxLayout="column" class="cm__details" fxLayoutGap="2pt">
                        <span>This carrier does not have Areas yet.</span>
                      </div>
                    </div>
                    <div fxLayout="row" fxLayoutGap="5px" *ngFor="let shipment of shipment.shipmentReferences">
                      <div fxFlex="40"><span>{{ shipment.shipRefDesc }}</span></div>
                      <div fxFlex="40"><span>{{ shipment.shipRefValue }}</span></div>
                      <div fxFlex="20"><span>{{ shipment.shipRefIsPrimary ? 'Yes' : 'No' }}</span></div>
                    </div>
                  </div>
                </ng-template>
                <!-- Finish Shipment References -->
              </mat-expansion-panel>
              <mat-expansion-panel class="result-panel">
                <mat-expansion-panel-header>
                  <div fxLayout="row" fxLayoutGap="2pt" class="cheader nested" fxLayoutAlign="start end">
                    <mat-icon class="material-icons-outlined">format_list_bulleted</mat-icon>
                    <span><b>Shipment Packages</b></span>
                  </div>
                </mat-expansion-panel-header>
                <!-- Start Shipment Package -->
                <ng-template matExpansionPanelContent>
                  <div fxLayout="column" fxLayoutGap="5pt" class="result-panel__details table-headers">
                    <div fxLayout="row" fxLayoutGap="5px" class="table-headers">
                      <div fxFlex="34"><span><b>DESCRIPTION</b></span></div>
                      <div fxFlex="16"><span><b>CLASS</b></span></div>
                      <div fxFlex="25"><span><b>QTY</b></span></div>
                      <div fxFlex="25"><span><b>WEIGHT</b></span></div>
                    </div>
                    <div fxLayout="row" fxLayoutGap="5px" *ngFor="let shipment of shipment.shipmentPackage">
                      <div fxFlex="34"><span>{{ shipment.packagingDesc }} </span></div>
                      <div fxFlex="16"><span>{{ shipment.freightClassID }} </span></div>
                      <div fxFlex="25" fxLayout="column">
                        <span> Planned: {{ shipment.quantityPlanned }} {{ shipment.quantityPlannedUOM }}</span>
                        <span> Ordered: {{ shipment.quantityOrdered }} {{ shipment.quantityOrderedUOM }}</span>
                        <span> Actual: {{ shipment.quantityActual }} {{ shipment.quantityActualUOM }}</span>
                        <span> Delivered: {{ shipment.quantityDelivered }} {{ shipment.quantityDeliveredUOM }}</span>
                      </div>
                      <div fxFlex="25" fxLayout="column">
                        <span> Planned: {{ shipment.weightPlanned }} {{ shipment.weightPlannedUOM }}</span>
                        <span> Ordered: {{ shipment.weightOrdered }} {{ shipment.weightOrderedUOM }}</span>
                        <span> Actual: {{ shipment.weightActual }} {{ shipment.weightActualUOM }}</span>
                        <span> Delivered: {{ shipment.weightDelivered }} {{ shipment.weightDeliveredUOM }}</span>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <!-- Finish Shipment Package -->
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          <br>
          <ng-container *ngIf="isCustomerReviewForm">
            <app-update-form
              [customerReview]="shipment"
              [directions]="directions"
            ></app-update-form>
          </ng-container>
        </ng-template>
      </mat-expansion-panel>
      <ng-container *ngIf="filterShipments?.length === 0">
        <span><b>Zero Records Found!</b></span>
      </ng-container>
    </ng-container>
  </mat-accordion>
</cdk-virtual-scroll-viewport>
